import { ContactPageSharp } from '@mui/icons-material';
import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import {
  setBuyOrder,
  setBuyOrderLoading,
  setBuyCloseEndFunds,
  setDropddownData,
  setFundDetail,
  setFundDocument,
  setFundDocumentLoading,
  setFundHoldings,
  setFundLoading,
  setFunds,
  setOrderAcceptLoading,
  setOrderCancelLoading,
  setSearchTypes,
  setSellOrder,
  setSellOrderLoading,
  setSingleBuyOrder,
  setSingleBuyOrderLoading,
  setSingleSellOrder,
  setSingleSellOrderLoading,
  setSuitabilityData,
  setSuitabilityStatus,
  setTradexDetails,
  setTransactions,
  setSellClientHoldingFunds,
  setSellOrderClientHoldingOfSelectedFund,
  setDownlaodFundTransDocument,
  setMyFunds,
} from '../slices/fund-slice';

export const getFundDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getFundDropdowns,
        setData: setDropddownData,
      })
    );
};

export const createRedemption = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.createRedemption,
        param_data: data,
        isSuccessMessage: true,
        onDone,
      })
    );
};

export const switchFunds = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.switchFunds,
        param_data: data,
        isSuccessMessage: true,
        onDone,
      })
    );
};

export const getSearchByType = (onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getSearchByType,
        onDone: (data) => {
          dispatch(setSearchTypes(data?.result?.searchByTypeList));
          onDone(data?.result?.searchByTypeList);
        },
      })
    );
};

export const getTransactions = (startDate, endDate, type) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.getTransactions,
        onDone: (data) => {
          dispatch(setTransactions(data?.result?.transactions));
        },
        param_data: `${startDate}&endDate=${endDate}&typeId=${type}`,
      })
    );
};

export const checkSuitabilityStatus = (params, onDone, onError) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        param_data: params,
        apiService: apiServices.checkSuitabilityStatus,
        onDone: (data) => {
          onDone && onDone();
          dispatch(setSuitabilityStatus(data));
        },
        isErrorMessage: false,
        onError: (err) => {
          dispatch(setSuitabilityStatus(err?.data?.message));
          onError();
        },
      })
    );
};

export const generateClientSuitability = (id, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.generateClientSuitability,
        param_data: id,
        onDone: (data) => {
          onDone && onDone();
        },
      })
    );
};

export const getTradExDetails = (id) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getTradExDetails,
        param_data: id,
        setData: setTradexDetails,
      })
    );
};

export const getFundHolding = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getFundHolding,
        param_data: params,
        setData: setFundHoldings,
      })
    );
};

export const getFundDocument = (id, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getFundDocument,
        param_data: id,
        setData: setFundDocument,
        setLoading: setFundDocumentLoading,
        onDone: onDone,
      })
    );
};

export const generateSuitabilityReport = (id, onDone, onError) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.generateSuitabilityReport,
        param_data: id,
        setLoading: setFundDocumentLoading,
        onDone: (val) => {
          dispatch(setSuitabilityStatus(val?.result?.value?.isSutiable ? 'suitable' : 'not_suitable'));
          // dispatch(setSuitabilityStatus(val?.result?.value?.sutibility?.result?.jsrS_sutabilityFlag ? 'suitable' : 'not_suitable'));
          onDone(val?.result?.value?.suitibilityDocument?.file);
        },
        onError: onError,
      })
    );
};

export const generateFundSuitability = (id, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.generateFundSuitability,
        param_data: id,
        setLoading: setFundDocumentLoading,
        onDone: (val) => {
          dispatch(setSuitabilityStatus(val?.result?.value?.jsrS_sutabilityFlag ? 'suitable' : 'not_suitable'));
          dispatch(setSuitabilityData(val?.result?.value));
          onDone();
        },
      })
    );
};

export const cancelTransaction = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.cancelTransaction,
        param_data: data,
        setLoading: setFundLoading,
        isSuccessMessage: true,
        onDone: () => onDone(),
      })
    );
};

export const getFunds = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getFunds,
        param_data: params,
        setLoading: setFundLoading,
        setData: setFunds,
      })
    );
};

export const getDownlaodFundTransDocument = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getDownlaodFundTransDocument,
        param_data: params,
        setLoading: setFundLoading,
        setData: setDownlaodFundTransDocument,
      })
    );
};

export const getBuyCloseEndFunds = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getBuyCloseEndFunds,
        param_data: params,
        setLoading: setFundLoading,
        setData: setBuyCloseEndFunds,
      })
    );
};

export const getSellClientHoldingFunds = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getSellClientHoldingFunds,
        param_data: params,
        setLoading: setFundLoading,
        setData: setSellClientHoldingFunds,
      })
    );
};

export const getSellOrderClientHoldingOfSelectedFund = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getSellOrderClientHoldingOfSelectedFund,
        param_data: params,
        setLoading: setFundLoading,
        setData: setSellOrderClientHoldingOfSelectedFund,
      })
    );
};

export const getFundDetail = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getFundDetail,
        setLoading: setFundLoading,
        param_data: params,
        onDone: (val) => {
          dispatch(setFundDetail(val?.result?.fundMaster?.[0] ?? val?.result?.fundMaster));
        },
      })
    );
};
export const signDocument = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.signDocument,
        param_data: data,
        setLoading: setFundDocumentLoading,
        onDone: (val) => onDone(val?.result),
      })
    );
};

export const createSubscription = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.createSubscription,
        param_data: data,
        onDone,
      })
    );
};

export const buyOrderFunds = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.buyOrderFunds,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};
export const sellOrderFunds = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.sellOrderFunds,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};

export const buyOrderCancel = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setOrderCancelLoading,
        apiService: apiServices.buyOrderCancel,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};
export const buyOrderAccept = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setOrderAcceptLoading,
        apiService: apiServices.buyOrderAccept,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};
export const sellOrderCancel = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setOrderCancelLoading,
        apiService: apiServices.sellOrderCancel,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};
export const sellOrderAccept = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setOrderAcceptLoading,
        apiService: apiServices.sellOrderAccept,
        param_data: data,
        onDone,
        isSuccessMessage: true,
      })
    );
};

export const getBuyOrder = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setBuyOrderLoading,
        apiService: apiServices.getBuyOrder,
        param_data: params,
        setData: setBuyOrder,
      })
    );
};

export const getSellOrder = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setSellOrderLoading,
        apiService: apiServices.getSellOrder,
        param_data: params,
        setData: setSellOrder,
      })
    );
};
export const getSingleBuyOrder = (params, investortTypeId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setSingleBuyOrderLoading,
        apiService: apiServices.getSingleBuyOrder,
        param_data: { params, investortTypeId },
        setData: setSingleBuyOrder,
      })
    );
};
export const getSingleSellOrder = (params, investortTypeId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setSingleSellOrderLoading,
        apiService: apiServices.getSingleSellOrder,
        param_data: { params, investortTypeId },
        setData: setSingleSellOrder,
      })
    );
};

export const getInvoiceReport = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundDocumentLoading,
        apiService: apiServices.getInvoiceReport,
        param_data: params,
        onDone: (data) => {
          onDone && onDone(data);
        },
      })
    );
};
export const getMyFunds = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.getMyFunds,
        param_data: params,
        setData: setMyFunds
      })
    );
};
export const downloadReport = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.downloadReport,
        param_data: params,
        onDone: val => onDone(val)
      })
    );
};
export const sendReport = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.sendReport,
        param_data: data,
        isSuccessMessage: true
      })
    );
};